import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Gridster, GridsterConfig, GridsterItem } from 'angular-gridster2';

import { DataCard } from '@models/module/main';
import { DataListViewAction } from '@models/module/main/dataListViewAction';
import { DataCardViewPartComponent } from '@module-instance/data-card/data-card-view-part/data-card-view-part.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-data-card-view',
  templateUrl: './data-card-view.component.html',
  styleUrls: ['./data-card-view.component.scss'],
  imports: [
    Gridster,
    GridsterItem,
    MatMenuModule,
    DataCardViewPartComponent,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataCardViewComponent {
  card = input.required<DataCard>();
  actions = input<DataListViewAction[]>([]);

  actionsFiltered = computed(() => {
    return this.actions().filter(a => a.alwaysOnRow === true && a.condition?.(this.card()));
  });

  readonly gridsterOptions: GridsterConfig = {
    gridType: 'verticalFixed',
    fixedRowHeight: 24,
    displayGrid: 'none',
    outerMargin: false,
    margin: 4,
    mobileBreakpoint: 1,
    setGridSize: true,
  };

  cardActionClick(action: DataListViewAction) {
    action.click && action.click(this.card());
  }
}
